export default __webpack_public_path__ + "static/media/8.Боловсролын байгууллагын багш удирдах ажилтны ёс зүй, манлайлал.a1805f01.png";